import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

import { Link } from "react-router-dom";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import StaffActivityCardLocateFileTable from "./StaffActivityCardLocateFileTable";
import StaffActivityCardRentTable from "./StaffActivityCardRentTable";
import StaffActivityCardSaleTable from "./StaffActivityCardSaleTable";
import { useLocation } from "react-router-dom";
import TransferConsultantFile from "./TransferConsultantFile";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomPagination from "../../../CustomPagination/CustomPagination";

const StaffActivityCardDetail = () => {
  const { userToken } = useContext(UserContext);
  const { state } = useLocation();
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const history = useHistory();

  const [filterActivityCard, setFilterActivityCard] = useState({
    locateFile: true,
    rent: false,
    sale: false,
    transerFile: false,
  });

  const [activityLocateFile, setActivityLocateFile] = useState([]);

  const [activityRent, setActivityRent] = useState([]);

  const [activitySale, setActivitySale] = useState([]);
  const [consultantAreas, setConsultantAreas] = useState([]);

  const changeFilterActivityCardHandler = name => {
    switch (name) {
      case "locateFile":
        setFilterActivityCard(prev => ({ ...prev, locateFile: true, rent: false, sale: false, transerFile: false }));
        break;
      case "rent":
        setFilterActivityCard(prev => ({ ...prev, rent: true, locateFile: false, sale: false, transerFile: false }));
        break;
      case "sale":
        setFilterActivityCard(prev => ({ ...prev, sale: true, locateFile: false, rent: false, transerFile: false }));
        break;
      case "transfer":
        setFilterActivityCard(prev => ({ ...prev, sale: false, locateFile: false, rent: false, transerFile: true }));
        break;
      default:
        break;
    }
  };

  useMemo(() => activityLocateFile, [activityLocateFile]);
  useMemo(() => activityRent, [activityRent]);
  useMemo(() => activitySale, [activitySale]);

  useEffect(() => {
    const dataHandler = async () => {
      const getConsultant = await axios.get(`Estate?UserId=${state.userId}&Take=10`, {
        headers: { authorization: "Bearer " + userToken },
      });

      const getConsultantData = await axios.get(`Consultant/GetConsultantById/${state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });

      const apiData = await getConsultant.data.data.data;
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getConsultant.data.data.pageCount };
      });
      setConsultantAreas(getConsultantData.data.data.accessibleAreas);
      setActivityLocateFile(apiData);
      setActivitySale(apiData.filter(item => item.totalPrice !== 0));
      setActivityRent(apiData.filter(item => item.rentPrice !== 0));
    };

    dataHandler();
    setIsLoading(false);
  }, [state, userToken]);

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 pb-4 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>{state?.name + " " + state?.family}</div>
                  </div>
                </div>

                {/* Total Staff Managment Info */}

                <div dir="rtl" className="d-flex align-items-center justify-content-md-between justify-content-center flex-wrap-reverse mt-3 pb-4 mx-4 px-2">
                  <div dir="rtl" className={`d-flex align-items-center justify-content-start my-2 ms-auto ${styles.total_filter_activity_card_box}`}>
                    <div
                      className={`px-4 ${styles.locateFile_filter_box} ${
                        filterActivityCard.locateFile ? styles.filter_activity_card_box_active : styles.filter_activity_card_box_deactive
                      }`}
                      onClick={() => changeFilterActivityCardHandler("locateFile")}
                      role="button">
                      فایل یابی
                    </div>
                    <div
                      className={`px-4 ${styles.rent_filter_box} ${
                        filterActivityCard.rent ? styles.filter_activity_card_box_active : styles.filter_activity_card_box_deactive
                      }`}
                      onClick={() => changeFilterActivityCardHandler("rent")}
                      role="button">
                      رهن و اجاره
                    </div>
                    <div
                      className={`px-4 ${styles.sale_filter_box} ${
                        filterActivityCard.sale ? styles.filter_activity_card_box_active : styles.filter_activity_card_box_deactive
                      }`}
                      onClick={() => changeFilterActivityCardHandler("sale")}
                      role="button">
                      فروش
                    </div>
                    <div
                      className={`px-4 ${styles.sale_filter_box} ${
                        filterActivityCard.transerFile ? styles.filter_activity_card_box_active : styles.filter_activity_card_box_deactive
                      }`}
                      onClick={() => changeFilterActivityCardHandler("transfer")}
                      role="button">
                      انتقال فایل
                    </div>
                  </div>

                  <div className={`d-flex justify-content-start align-items-center`}>
                    <img className={`${styles.image_staff_card_detail}`} loading="lazy" src={`https://backdev.azrmelk.com${state?.imageUrl}`} alt="avatar" />

                    <div className={`me-3 text-right`}>
                      <h4 className={`${styles.title_head_staff_card_box}`}> {state?.name + " " + state?.family} </h4>
                      <div className={`d-flex align-items-center justify-content-center flex-wrap mb-0 ${styles.subTitle_head_staff_card_box}`}>
                        {/*consultantAreas?.map((item, i) => (
                                                        <div key={i} className='mx-1'>{item.value}</div>
                                                    ))*/}
                      </div>
                    </div>
                  </div>
                </div>

                <div dir="rtl" className={`mt-3 pb-4 mx-4 px-2 ${styles.activity_default_height}`}>
                  {filterActivityCard.locateFile && <StaffActivityCardLocateFileTable activityLocateFile={activityLocateFile} />}
                  {filterActivityCard.rent && (
                    <StaffActivityCardRentTable staffActivityCardTable={activityRent}>
                      <div className={`d-flex justify-content-between align-items-center`}>
                        <div scope="col" className={`text-center col-3 ${styles.table_head_th}`}>
                          {" "}
                          نام فایل{" "}
                        </div>
                        <div scope="col" className={`text-center col-3 ${styles.table_head_th}`}>
                          {" "}
                          تاریخ ایجاد{" "}
                        </div>
                        <div scope="col" className={`text-center col-3 ${styles.table_head_th}`}>
                          {" "}
                          تاریخ واگذاری به رهن{" "}
                        </div>
                        <div scope="col" className={`text-center col-3 ${styles.table_head_th}`}>
                          {" "}
                          جزئیات{" "}
                        </div>
                      </div>
                    </StaffActivityCardRentTable>
                  )}
                  {filterActivityCard.sale && (
                    <StaffActivityCardSaleTable staffActivityCardTable={activitySale}>
                      <div className={`d-flex justify-content-between align-items-center`}>
                        <div scope="col" className={`text-center col-3 ${styles.table_head_th}`}>
                          {" "}
                          نام فایل{" "}
                        </div>
                        <div scope="col" className={`text-center col-3 ${styles.table_head_th}`}>
                          {" "}
                          تاریخ ایجاد{" "}
                        </div>
                        <div scope="col" className={`text-center col-3 ${styles.table_head_th}`}>
                          {" "}
                          تاریخ فروش{" "}
                        </div>
                        <div scope="col" className={`text-center col-3 ${styles.table_head_th}`}>
                          {" "}
                          جزئیات{" "}
                        </div>
                      </div>
                    </StaffActivityCardSaleTable>
                  )}
                  {filterActivityCard.transerFile && <TransferConsultantFile state={state} />}
                </div>

                <Stack
                  className={Dstyles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                </Stack>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu managePersonal manageActiviyStaff />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getFiles = await axios.get(`Estate?UserId=${state.userId}&PageId=${value}&Take=10`, {
      headers: { authorization: "Bearer " + userToken },
    });
    const apiData = await getFiles.data.data.data;
    setActivityLocateFile(apiData);
    setActivitySale(apiData.filter(item => item.totalPrice !== 0));
    setActivityRent(apiData.filter(item => item.rentPrice !== 0));
    setPage(prev => {
      return { ...prev, pageCount: getFiles.data.data.pageCount, pageNumber: value };
    });
    setIsLoading(false);
  }
};

export default StaffActivityCardDetail;
